import { Group, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { DeliveryDetails } from 'types/lcms/courses';

interface DeliveryDetailProps {
  data?: DeliveryDetails;
}

const DeliveryDetail: React.FC<DeliveryDetailProps> = ({ data }) => {
  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <HiOutlineDocumentText />
          <Text c={'dark'} fw={700}>
            Delivery Details
          </Text>
        </Group>
        <Stack gap={0}>
          <Text c={'grey.5'} fw={600} fz={14}>
            Course Category
          </Text>
          <Text fz={14} c={'dark'} tt={'capitalize'}>
            {data?.deliveryType || '-'}
          </Text>
        </Stack>
        <Stack gap={0}>
          <Text c={'grey.5'} fw={600} fz={14}>
            Group Training Type
          </Text>
          <Text fz={14} c={'dark'}>
            {data?.groupTrainingType || '-'}
          </Text>
        </Stack>
        <Stack gap={0}>
          <Text c={'grey.5'} fw={600} fz={14}>
            Learning Hours
          </Text>
          <Text fz={14} c={'dark'}>
            {data?.learningHours ? `${data?.learningHours} H` : '-'}
          </Text>
        </Stack>
      </Stack>
    </Card>
  );
};

export default DeliveryDetail;
